export class CertPeriodicityMonthEntity {
    id:number;
    periodicityId:number;
    monthId:number;
    
    constructor() { }
}